<div class="stations-container">
  <div class="stations-scrollable" *ngIf="sacClientContext && sacStructure">
    <ng-container *ngFor="let stationGroup of this.stationGroups">
      <ng-container *ngIf="sacStructure.stationGroup != null && sacStructure.stationGroup.id === stationGroup.id">
        <div class="stations-group" *ngFor="let stationSet of stationGroup.stationSets, let i = index">

          <ng-container *ngIf="sacStructure.stationSet == null || stationSet.id === sacStructure.stationSet.id">

            <sc-content-spacer [vertical]="true" *ngIf="i > 0"></sc-content-spacer>

            <sc-sub-title>{{stationSet.name}}</sc-sub-title>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <div class="stations-list">

              <ng-container *ngFor="let station of stationSet.stations">

                <div>
                  <app-sac-station-item (click)="clickStation(stationSet, station)" [stationSet]="stationSet"
                    [station]="station" [sacClientContext]="sacClientContext" [selected]="station === selection?.station && stationSet === selection?.stationSet"></app-sac-station-item>
                  <div class="bottom-spacer" [ngClass]="{'highlight': 
                  selection?.stationSet?.id === stationSet.id 
                  && selection?.station?.id===station.id 
                  && station.stationUsage.transports?.length !== 0 
                  && sacClientContext.showStationUsageDetails===true}"></div>
                </div>

                <app-sac-station-details class="station-details" [stationSet]="stationSet" [station]="station"
                  [sacClientContext]="sacClientContext" [dashboardContext]="dashboardContext"
                  *ngIf="selection?.stationSet?.id === stationSet.id && selection?.station?.id===station.id && station.stationUsage.transports?.length !== 0 && sacClientContext.showStationUsageDetails===true">
                </app-sac-station-details>

              </ng-container>
            </div>

          </ng-container>

        </div>
      </ng-container>
    </ng-container>
  </div>
</div>